import { render, staticRenderFns } from "./ContractDetails.vue?vue&type=template&id=aff16416&scoped=true&lang=pug"
import script from "./ContractDetails.vue?vue&type=script&lang=js"
export * from "./ContractDetails.vue?vue&type=script&lang=js"
import style0 from "./ContractDetails.vue?vue&type=style&index=0&id=aff16416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff16416",
  null
  
)

export default component.exports